import axios, {AxiosResponse, AxiosError} from 'axios';
import cors from "cors";

export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Patch = 'PATCH',
  Delete = 'DELETE',
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
  //console.info(`[response] [${JSON.stringify(response)}]`);
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  // let originalRequest: any = error.config;
  //@ts-ignore
  // if (error) {
  //   axios.defaults.headers.common['Authorization'] = `Bearer ${process.env.REACT_APP_TOKEN}`;
  //   return axios(originalRequest);
  // }

  return Promise.reject(error);
};

axios.defaults.headers.common['Authorization'] =`Bearer ${process.env.REACT_APP_TOKEN}`;
axios.interceptors.request.use((config) => {
  //console.info(`[request] [${JSON.stringify(config)}]`);
  return config;
}, (error) => {
  // Do something with request error
  console.info(`[error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
});
axios.interceptors.response.use(onResponse, onResponseError);

export const httpClient = (url: string, method: HttpMethod, bodyData: any) => {
  return new Promise((resolve, reject) => {
    const baseURL = process.env.REACT_APP_BASE_API_URL;
    //console.log(baseURL);
    const params: any = {method, url: `${baseURL}${url}`};

    const signed = cors({
      origin: '*',
      methods: method,
      allowedHeaders: 'true',
    });
    try {
        const data = axios({
          ...signed,
          data: JSON.stringify(params.body),
          method: method,
          url: `${baseURL}${url}`,
        });
      /* istanbul ignore next */
        data.then((response) => {
          console.log('Successfully received data: ', response);
          resolve(response);
        }).catch((error) => {
          if(error) {
            return error.message;
          }
          reject(error);
        });
    } catch (error) {
      reject(error);
    }
  });
};
